module.exports = "<div class=\"LP_mainwrapping_container\"></div>";